import React from 'react';
import './App.css';
import MainContent from './MainContent'; // Import the MainContent component

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <MainContent />  {/* Use the MainContent component */}
      </header>
    </div>
  );
}

export default App;
